declare var $: any;

import { Spinner } from "../modules/spinner";
import { Autosave } from "../modules/autosave";

export class ProjectList {
    static init() {
        ProjectList.initDeletionListeners();
    }

    static initDeletionListeners() {
        $(".js-remove-project").on("click", ProjectList.deleteProject);
    }

    static deleteProject(e: Event) {
        e.preventDefault();

        const $button = $(this);
        const projectName = $button.data("project-name");

        if (!confirm(`Är du säker på att du radera projektet '${projectName}' ?`))
            return;
        const verb = $button.data("verb");
        const uri = $button.data("deletion-uri");

        Spinner.spin($button);
        $(Autosave.savingNotificationClass).show();

        $.ajax({
            type: verb,
            url: uri
        }).done((responseData: any) => {
            $(".js-project-list").html(responseData);
        }).always(() => {
            Spinner.stop($button);
            $(Autosave.savingNotificationClass).hide();
            ProjectList.initDeletionListeners();
        });
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/partials/projectList.ts